module.exports = __webpack_public_path__ + "static/media/dog_01.fd9fc7b1.jpg";